
import "components/template_pdp_unit/template_pdp_unit";
import "components/slider_with_semi_visible_next_slide/slider_with_semi_visible_next_slide";
import "components/highlights_themed_pdp_slider/highlights_themed_pdp_slider";
import "components/similar_unit_types_slider/similar_unit_types_slider";

import "components/beds_bathrooms_slider/beds_bathrooms_slider";
import "components/pdp_first_block/pdp_first_block";
import "components/first_block_overlay/first_block_overlay"
import "components/pdp_3d_tour/pdp_3d_tour";
import "components/pdp_summary/pdp_summary";
import "components/pdp_amenities/pdp_amenities";
import "components/breadcrumbs/breadcrumbs";
import "components/pdp_faq/pdp_faq";
import "components/booking_fee_tooltip/booking_fee_tooltip";
import "components/cart_icon/cart_icon"
import "components/resort_card/resort_card"

// revinate
import "components/revinate_modal/revinate_modal"

const resizeDependent = () => {
  const vh = window.innerHeight * 0.01;
  let vw;

const wpSiteBlocks = document.body;
if(wpSiteBlocks) {
vw = wpSiteBlocks.clientWidth * 0.01;
} else {
vw = document.documentElement.clientWidth * 0.01;
}
document.documentElement.style.setProperty("--vh", `${vh}px`);
document.documentElement.style.setProperty("--vw", `${vw}px`);
};

function updateStyleVariables() {
window.addEventListener('resize', function () {
    resizeDependent();
});

resizeDependent();
}

updateStyleVariables();
